//Login
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN_FAILED = 'LOGIN_FAILED';
var LOGOUT = 'LOGOUT';
var PASSWORD_RESET_FAILED = "PASSWORD_RESET_FAILED";
var PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
var VERIFY_PASSWORD_RESET_SUCCESS = "VERIFY_PASSWORD_RESET_SUCCESS";
var VERIFY_PASSWORD_RESET_FAILURE = "VERIFY_PASSWORD_RESET_FAILURE";
var SET_IS_LOADING = "SET_IS_LOADING"; // Users
var GET_USERS = 'GET_USERS';
var CREATE_USER = 'CREATE_USER';
var UPDATE_USER = 'UPDATE_USER';
var DELETE_USER = 'DELETE_USER';
var SET_CURRENT_USER = 'SET_CURRENT_USER'; // Contact

var CONTACT_SUBMIT = 'CONTACT_SUBMIT';
var DELETE_CONTACT = 'DELETE_CONTACT';
var GET_CONTACTS = 'GET_CONTACTS';
var GET_CONTACT = 'GET_CONTACT';

export { CONTACT_SUBMIT as C, DELETE_CONTACT as D, GET_CONTACTS as G, LOGIN_FAILED as L, PASSWORD_RESET_FAILED as P, SET_IS_LOADING as S, UPDATE_USER as U, VERIFY_PASSWORD_RESET_FAILURE as V, GET_CONTACT as a, DELETE_USER as b, CREATE_USER as c, GET_USERS as d, LOGIN_SUCCESS as e, LOGOUT as f, PASSWORD_RESET_SUCCESS as g, VERIFY_PASSWORD_RESET_SUCCESS as h, SET_CURRENT_USER as i };
